import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType, SlotsType } from 'vue'

export const edittableColumnLovProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
  // 是否可编辑
  editable: Boolean,
  cellEditable: Boolean,
  // input属性
  maxlength: [String, Number],
  placeholder: String,
  fillMapping: [String, Function] as PropType<string | ((row: any, params: Record<string, any>) => void)>,
})

export type EdittableColumnLovProps = Partial<ExtractPropTypes<ReturnType<typeof edittableColumnLovProps>>>

export default defineComponent({
  name: 'OEdittableColumnLov',
  inheritAttrs: false,
  props: edittableColumnLovProps(),
  slots: Object as SlotsType<{
    default: any
  }>,
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
